module.exports = __webpack_public_path__ + "static/media/chat_bot.jpg?v=13abd72f";